import moment from "moment";
import numeral from "numeral";

export const providerFor = (factory) => {
  let instance = null;
  return () => {
    if (instance !== null) return instance;
    instance = factory();
    return instance;
  };
};

export const handleNotAvailable = (value, naText = "N/A") => {
  const isNotAvailable = value === "NaN" || Number.isNaN(value) || value === undefined || value === null;
  return isNotAvailable ? naText : value;
};

export const parseDateTime = (dateString) => moment(dateString, "YYYYMMDD-HH-mm-SS");

export const formatBigNumber = (number) => numeral(number).format("0.[00]a").toUpperCase();
